module.exports = __webpack_public_path__ + "img/YouPlusZH-5.508fe645.jpg";